/* eslint-disable */
import { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, IconButton, InputAdornment, Grid } from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import Divider from '@material-ui/core/Divider';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import { AESEncryptionParam, AESDecryptionParam } from '../../../../helpers/AesEncrypt';
import services from '../Services';
import { ToastContainer, toast } from 'react-toastify';
import { AlertDialog } from './../../Common/AlertDialog';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import permissionAuth from 'src/utils/permissionAuth';

export default function AddEdit(props) {
  const screenCode = 'PRODUCTCATEGORY';
  const navigate = useNavigate();
  const { categoryID } = useParams();
  const [productCategoryDetails, setProductCategoryDetails] = useState([]);
  const [message, setMessage] = useState("Save Confirmation");
  const [message2, setMessage2] = useState("Update Confirmation");
  const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);
  const [EnableConfirmMessage2, setEnableConfirmMessage2] = useState(false);

  const [pageProps, setPageProps] = useState({
    editingID: 0,
    isEdit: false,
    submitButtonName: "Save",
    pageheadername: "Add product category"
  });

  const [formData, setFormData] = useState({
    productCategoryID: 0,
    categoryCode: "",
    productCategoryName: "",
    isActive: true,
    decription: ""
  });

  const ProductCategorySearchSchema = Yup.object().shape({
    categoryCode: Yup.string().required('Category code required'),
    productCategoryName: Yup.string().required('Category name required'),
    decription: Yup.string().required('Descrption required')
  });

  const formik = useFormik({
    initialValues: {
      categoryCode: formData.categoryCode,
      productCategoryName: formData.productCategoryName,
      isActive: formData.isActive,
      decription: formData.decription

    },
    validationSchema: ProductCategorySearchSchema,
    onSubmit: (values) => {
      if (pageProps.isEdit > 0) {
        setProductCategoryDetails(values);
        setEnableConfirmMessage2(true);
      } else {
        setProductCategoryDetails(values);
        setEnableConfirmMessage(true);
      }
    },
  });
  const handleKeyDown = (e) => {
    if (e.key === " " && name.length === 0) {
      e.preventDefault();
    }
  };

  async function SaveProductCategory() {
    var res = await services.SaveProductCategory(productCategoryDetails);
    if (res.statusCode === "Success") {
      toast.success("Product Category Saved Succesfully");
      setTimeout(() => {
        navigate('/dashboard/productcategory/listing');
      }, 1500);

    } else {
      toast.error(res.message);
    }
  }

  async function UpdateProductCategory() {
    var res = await services.UpdateProductCategory(productCategoryDetails, pageProps.editingID);
    if (res.statusCode === "Success") {
      toast.success("Product Category Updated Succesfully");
      setTimeout(() => {
        navigate('/dashboard/productcategory/listing');
      }, 1500);
    } else {
      toast.error(res.message);
    }
  }

  const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

  let decrypted = 0;

  useEffect(() => {
    getPermissions();
  }, []);

  useEffect(() => {

    decrypted = AESDecryptionParam(categoryID);
    if (decrypted != 0) {
      setPageProps({
        ...pageProps,
        isEdit: true,
        submitButtonName: "Update",
        pageheadername: "Update product category",
        editingID: parseInt(decrypted)
      })
    }
  }, []);

  useEffect(() => {

    if (pageProps.editingID > '0') {
      trackPromise(getproductcategories(pageProps.editingID))
    }

  }, [pageProps.editingID]);

  async function getPermissions() {
    var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITCATEGORY');

    if (isAuthorized === undefined) {
      navigate('/404');
    }
  }

  async function getproductcategories(productCategoryID) {

    var productCategory = await services.GetProductCategoryDetailsByProductCategoryID(productCategoryID)
    setValues({
      productCategoryName: productCategory.productCategoryName,
      decription: productCategory.decription,
      isActive: productCategory.isActive,
      categoryCode: productCategory.categoryCode
    })

    setFormData(productCategory)

  }

  function confirmData(y) {
    if (y) {
      SaveProductCategory();
    }
  }

  function confirmData2(y) {
    if (y) {
      UpdateProductCategory();
    }
  }

  return (
    <>
      <LoadingComponent />
      <Page title="Add Product Category |  FAPS">
        <Container>
          <CommonPageHeader
            path="/dashboard/productcategory/listing"
            btname="Back"
            pageName={pageProps.pageheadername}
          />
          <FormikProvider value={formik}>
            <ToastContainer
              position="bottom-right"
              pauseOnHover
            />
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <Stack spacing={2}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Category Code *"
                    value={formik.values.categoryCode}
                    onChange={formik.handleChange}
                    onKeyDown={handleKeyDown}
                    disabled={pageProps.isEdit}
                    {...getFieldProps('categoryCode')}
                    error={Boolean(touched.categoryCode && errors.categoryCode)}
                    helperText={touched.categoryCode && errors.categoryCode}
                  />
                  <TextField
                    fullWidth
                    size="small"
                    label="Category name *"
                    value={formik.values.productCategoryName}
                    onChange={formik.handleChange}
                    onKeyDown={handleKeyDown}
                    {...getFieldProps('productCategoryName')}
                    error={Boolean(touched.productCategoryName && errors.productCategoryName)}
                    helperText={touched.productCategoryName && errors.productCategoryName}
                  />
                  <TextField
                    fullWidth
                    size="small"
                    label="Description  *"
                    value={formik.values.decription}
                    onChange={formik.handleChange}
                    {...getFieldProps('decription')}
                    error={Boolean(touched.decription && errors.decription)}
                    helperText={touched.decription && errors.decription}
                  />
                </Stack>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <FormControlLabel
                    control={
                      <Switch
                        value={formik.values.isActive}
                        checked={formik.values.isActive}
                        {...getFieldProps('isActive')}
                        onClick={formik.handleChange}
                        color="error"
                        name="isActive"
                        inputProps={{ 'aria-label': 'primary checkbox' }}
                      />}
                    label="Is Active"
                  />
                  <Grid item md={10.5} xs={12}>
                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                      <LoadingButton
                          size="small"
                          type="button"
                          color='error'
                          variant="outlined"
                          disabled={pageProps.isEdit}
                          onClick={() => formik.resetForm()}
                        >
                          Clear
                        </LoadingButton>
                        <LoadingButton
                          size="small"
                          color='secondary'
                          type="submit"
                          variant="outlined"
                        >
                          {pageProps.submitButtonName}
                      </LoadingButton>
                    </Stack>
                  </Grid>
                </Stack>
                <br/>
              </Stack>
            </Form>
          </FormikProvider>
        </Container>
        <div hidden={true}>
          <Grid item>
            <AlertDialog confirmData={confirmData} headerMessage={message} viewPopup={EnableConfirmMessage}
              discription={"Are you sure want to save new category ?"} setViewPopup={setEnableConfirmMessage} />
          </Grid>
        </div>
        <div hidden={true}>
          <Grid item>
            <AlertDialog confirmData={confirmData2} headerMessage={message2} viewPopup={EnableConfirmMessage2}
              discription={"Are you sure want to update category ?"} setViewPopup={setEnableConfirmMessage2} />
          </Grid>
        </div>
      </Page>
    </>
  )
}